var ls,
listing = {
	settings: {
		listingItem: $('.layout.listing .item'),
	},
	init: function() {
		ls = this.settings;
		this.bindUIActions();
		console.log('listings loaded!');
	},
	bindUIActions: function() {
		$('.layout.listing .search select').on('change', function() {

		    ls.listingItem.hide();
		    ls.listingItem.find('[data-category-id=' + this.value + ']').show();

		});



	}
};
